import { useEffect, useState } from 'react'

import { AccordionItem } from '../Accordion/Accordion'
import Markdown from '../Markdown/Markdown'

import DownArrow from '../../assets/images/down-arrow.svg'
import UpArrow from '../../assets/images/up-arrow.svg'

import styles from './Disclosure.module.scss'

const Disclosure = ({ section }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  useEffect(() => {
    setActiveIndex(null)
  }, [])

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <>
      {section && section?.length > 0 && (
        <div className={styles.accordion}>
          {section?.map((tab, idx) => (
            <AccordionItem
              key={`disclosure-${idx}`}
              onClick={() => handleClick(idx)}
              question={tab?.question}
              isOpen={idx === activeIndex}
              collapseIcon={UpArrow}
              expandIcon={DownArrow}
            >
              <Markdown
                className={styles.disclosureMarkdown}
                content={tab?.answer}
              />
            </AccordionItem>
          ))}
        </div>
      )}
    </>
  )
}

export default Disclosure
